// ----------- import external dependencies -----------
import { lazy } from "react";

// ----------- import pages with code splitting ----------
// import auth pages
const SignUp = lazy(() => import("../screens/auth/SignUp/signup"));
const SignIn = lazy(() => import("../screens/auth/Signin/signin"));
const ForgotPassword = lazy(
  () => import("../screens/auth/ForgotPassword/forgotPassword")
);
const NewPassword = lazy(
  () => import("../screens/auth/NewPassword/newpassword")
);
const Authentication = lazy(
  () => import("../screens/auth/Authentication/auth")
);
const AccountSettings = lazy(
  () => import("../screens/auth/AccountSetting/accountSetting")
);

// import school pages
const Dashboard = lazy(() => import("../screens/Dashboard/dashboard"));
const Parent = lazy(() => import("../screens/school/Parent/parent"));
const Settings = lazy(() => import("../screens/school/Settings/settings"));
const Ticket = lazy(() => import("../screens/school/tickets/tickets"));
const Account = lazy(() => import("../screens/school/account/account"));
const Report = lazy(() => import("../screens/school/report/report"));
const Student = lazy(() => import("../screens/school/student/student"));
const RegisterStudent = lazy(
  () => import("../screens/school/student/register-student/RegisterStudent")
);
const EditStudent = lazy(
  () => import("../screens/school/student/edit-student/EditStudent")
);
const OverView = lazy(
  () => import("../screens/school/student/overview/Overview")
);
const ViewReport = lazy(
  () => import("../screens/school/student/view-report/ViewReport")
);
const StudentClass = lazy(() => import("../screens/school/class/StudentClass"));

const CreateClass = lazy(
  () => import("../screens/school/class/create-class/CreateClass")
);

const EditClass = lazy(
  () => import("../screens/school/class/edit-class/EditClass")
);

const ViewTicket = lazy(
  () => import("../screens/school/tickets/view-ticket/ViewTicket")
);

const AddNewTicket = lazy(
  () => import("../screens/school/tickets/add-new-ticket/AddNewTicket")
);

const ParentOverView = lazy(
  () => import("../screens/school/Parent/parent-overview/ParentOverView")
);

const RegisterParent = lazy(
  () => import("../screens/school/Parent/register-parent/RegisterParent")
);

const EditParent = lazy(
  () => import("../screens/school/Parent/edit-parent/EditParent")
);

// ------------ auth routes ------------
export const authRoutes = [
  {
    path: "signup",
    component: SignUp,
  },
  {
    path: "login",
    component: SignIn,
  },
  {
    path: "forgot-password",
    component: ForgotPassword,
  },
  {
    path: "new-password",
    component: NewPassword,
  },
  {
    path: "auth-verification",
    component: Authentication,
  },
  {
    path: "account-setting",
    component: AccountSettings,
  },
];

// ------------ school routes ----------
export const schoolRoutes = [
  {
    path: "dashboard",
    component: Dashboard,
  },
  {
    path: "parent",
    component: Parent,
  },
  {
    path: "settings",
    component: Settings,
  },
  {
    path: "report",
    component: Report,
  },
  {
    path: "ticket",
    component: Ticket,
  },
  {
    path: "account",
    component: Account,
  },
  {
    path: "student",
    component: Student,
  },
  {
    path: "edit-student/:id",
    component: EditStudent,
  },
  {
    path: "register-student",
    component: RegisterStudent,
  },
  {
    path: "over-view/:id",
    component: OverView,
  },
  {
    path: "view-report",
    component: ViewReport,
  },
  {
    path: "class",
    component: StudentClass,
  },
  {
    path: "create-class",
    component: CreateClass,
  },
  { path: "edit-class/:id", component: EditClass },
  {
    path: "view-ticket/:id",
    component: ViewTicket,
  },
  {
    path: "add-new-ticket",
    component: AddNewTicket,
  },
  { path: "parent-overview/:id", component: ParentOverView },
  { path: "register-parent", component: RegisterParent },
  { path: "edit-parent/:id", component: EditParent },
];
